import { h } from 'preact';
export const MicOff = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "1", y1: "1", x2: "23", y2: "23" }),
        h("path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6" }),
        h("path", { d: "M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23" }),
        h("line", { x1: "12", y1: "19", x2: "12", y2: "23" }),
        h("line", { x1: "8", y1: "23", x2: "16", y2: "23" })));
};
//# sourceMappingURL=mic-off.js.map